<template>
  <div>
    <v-btn
      small
      class="mb-2"
      @click="hidden = !hidden"
    >Prílohy ({{ size }})</v-btn>
    <div :hidden="hidden">
      <v-row>
        <v-col cols="12">
          <slot></slot>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>

export default {
  name: "HiddenAttachments",
  props: {
    size: Number
  },
  data: () => ({
    hidden: true,
  }),
};
</script>>